var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { StatusClassNames } from "../types/StatusClassNames";
// Ставит is-stuck элементу сразу после .sticky-sentinel, пока тот прилип.
// Прилипание может включаться только с брейкпоинта, поэтому смотрим на вычисленный position, а не дублируем медиазапрос.
export default function initStickyState() {
    document.querySelectorAll('.sticky-sentinel').forEach(function (sentinel) {
        var target = sentinel.nextElementSibling;
        if (!target) {
            return;
        }
        new IntersectionObserver(function (_a) {
            var _b = __read(_a, 1), entry = _b[0];
            var isAbove = entry.boundingClientRect.top < 0;
            var isSticky = getComputedStyle(target).position === 'sticky';
            target.classList.toggle(StatusClassNames.stuck, isSticky && !entry.isIntersecting && isAbove);
        }).observe(sentinel);
    });
}
